import { useEffect, useState } from 'react'
import {
  Datagrid,
  Filter,
  List,
  SearchInput,
  TextField,
  DateInput,
  downloadCSV,
  useRecordContext,
  useDataProvider,
  useRefresh,
  useListContext,
} from 'react-admin'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField as TextFieldUI,
} from '@material-ui/core'
import jsonExport from 'jsonexport/dist'
import moment from 'moment'

const VisitPeriod = (props) => (
  <Grid container spacing={2}>
    <Grid item>
      <DateInput source="visit_date_gte" label="Du" />
    </Grid>
    <Grid item>
      <DateInput source="visit_date_lte" label="Au" />
    </Grid>
  </Grid>
)

const VisitsGlobalListFilter = (props) => {
  const context = useListContext()
  useEffect(() => {
    if (!context.displayedFilters.visit_date) {
      const { visit_date_gte, visit_date_lte, ...values } = context.filterValues
      context.setFilters({ ...values })
    }
  }, [context.displayedFilters.visit_date])
  useEffect(() => {
    console.log({ context: context.data })
    props.setData(() => {
      return context.data
    })
  }, [context.data])
  return (
    <Filter {...props}>
      <SearchInput source="copro_code" />
      <VisitPeriod source="visit_date" />
    </Filter>
  )
}
const Facture = (props) => {
  const record = useRecordContext()
  const dataProvider = useDataProvider()
  const refresh = useRefresh()
  const [facture, setFacture] = useState(record.facturee)
  const [openModal, setOpenModal] = useState(false)
  const [values, SetValues] = useState({
    montantHt: null,
    montantttc: null,
  })
  const handleClose = () => {
    setOpenModal(false)
  }
  const handleSaveMontant = () => {
    dataProvider
      .update('tickets/update_process_fields', {
        id: record.ticket_id,
        data: {
          facturee: 'Oui',
          montant_ht: values.montantHt,
          montant_ttc: values.montantttc,
        },
      })
      .then((r) => {
        setFacture('Oui')
        handleClose()
        refresh()
      })
      .catch((e) => {
        console.log({ e })
      })
  }
  const isDisabled = (vals) => {
    if (
      record.montant_ht == vals.montantHt &&
      record.montant_ttc == vals.montantttc
    ) {
      return true
    }
    return false
  }
  const handleChange = (e) => {
    if (e.target.value == 'Oui') {
      setOpenModal(true)
    } else {
      setFacture(e.target.value)
      dataProvider
        .update('tickets/update_process_fields', {
          id: record.ticket_id,
          data: { facturee: e.target.value },
        })
        .then((r) => {
          refresh()
        })
        .catch((e) => {
          console.log({ e })
        })
    }
  }
  return (
    <>
      <Box sx={{ minWidth: 60 }}>
        <FormControl fullWidth>
          <Select
            id="select"
            value={facture}
            label="Facturé"
            onChange={handleChange}
          >
            <MenuItem value={'Oui'}>Oui</MenuItem>
            <MenuItem value={'Non'}>Non</MenuItem>
            <MenuItem value={'Inclus'}>Inclus</MenuItem>
            <MenuItem value={'Non facturable'}>Non facturable</MenuItem>
          </Select>
        </FormControl>
        <Dialog
          open={openModal}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{'Ajouter montant HT/TTC'}</DialogTitle>
          <DialogContent>
            <TextFieldUI
              id="ht"
              label="Montant HT"
              type="text"
              value={values.montantHt}
              style={{ width: '100%', marginBottom: '16px' }}
              InputLabelProps={{
                shrink: true,
                required: true,
              }}
              onChange={(e) => {
                const regex = /^\d+(,\d{0,2})?$/
                if (regex.test(e.target.value) || !e.target.value) {
                  SetValues({ ...values, montantHt: e.target.value })
                }
              }}
            />
            <TextFieldUI
              id="ttc"
              label="Montant TTC"
              type="text"
              value={values.montantttc}
              style={{ width: '100%', marginBottom: '16px' }}
              InputLabelProps={{
                shrink: true,
                required: true,
              }}
              onChange={(e) => {
                const regex = /^\d+(,\d{0,2})?$/
                if (regex.test(e.target.value) || !e.target.value) {
                  SetValues({ ...values, montantttc: e.target.value })
                }
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Fermer</Button>
            <Button
              onClick={() => {
                handleSaveMontant()
              }}
              disabled={isDisabled(values)}
            >
              Enregistrer
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  )
}
const VisitDate = () => {
  const record = useRecordContext()
  return (
    <>
      {record.visit_date ? moment(record.visit_date).format('DD/MM/YYYY') : ''}
    </>
  )
}
const exporter = (records) => {
  const recordsExport = records.map((record) => {
    const { id, created, ticket_id, ...recordForExport } = record // omit id and created ..
    return recordForExport
  })
  jsonExport(
    recordsExport,
    {
      headers: ['copro_code', 'libelle', 'visit_type', 'duree', 'visit_date'], // order fields in the export
    },
    (err, csv) => {
      downloadCSV(csv, 'visits') // download as 'visits.csv` file
    }
  )
}

export const VisitsGlobalList = (props) => {
  const [data, setData] = useState()
  const [key, setKey] = useState(Math.random().toString(36).substring(7))
  useEffect(() => {
    setKey(() => {
      return Math.random().toString(36).substring(7)
    })
  }, [data])
  return (
    <List
      exporter={exporter}
      hasCreate={false}
      perPage={100}
      filters={<VisitsGlobalListFilter setData={setData} />}
      {...props}
    >
      <Datagrid bulkActionButtons={false} data={data} key={key}>
        <TextField source="copro_code" />
        <VisitDate source="visit_date" />
        <TextField source="duree" />
        <TextField source="libelle" />
        <TextField source="montant_ttc" label="Montant TTC" />
        <Facture source="facturé" />
        <TextField source="visit_type" label="Type de visite" />
      </Datagrid>
    </List>
  )
}
